import { render } from "./ClassifyFilter.vue?vue&type=template&id=bf87155c"
import script from "./ClassifyFilter.vue?vue&type=script&lang=js"
export * from "./ClassifyFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__